import { useEffect, useState } from 'react';

export function useIsMobile(breakpoint = 768) {
  const [m, setM] = useState(
    typeof window !== 'undefined' && window.innerWidth <= breakpoint
  );
  useEffect(() => {
    const handler = () => setM(window.innerWidth <= breakpoint);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [breakpoint]);
  return m;
}
